export default "__VITE_ASSET__BaEuecuc__"